import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermisosService } from '@core/services/permisos.service';
import { RUTAS } from '@core/constants/rutas.constants';
import { PERMISOS_GESTION_CLIENTE } from '@shared/constants/permisos';
import { RUTAS_GESTION_CLIENTE } from '@gestion-cliente/constants/gestion-cliente.constants';

const PERMISOS_ORGANIZACION_PROPIA = [PERMISOS_GESTION_CLIENTE.GESTIONAR_PROPIA, PERMISOS_GESTION_CLIENTE.GESTIONAR_FONDEADOR];

export const accesoBusquedaClienteGuard: CanActivateFn = () => {
  const permisosService = inject(PermisosService);
  const router = inject(Router);

  if (permisosService.tienePermisoSync(PERMISOS_GESTION_CLIENTE.GESTIONAR_TODOS)) {
    return true;
  }

  return permisosService.tieneAlgunPermiso(PERMISOS_ORGANIZACION_PROPIA)
    ? router.createUrlTree([RUTAS_GESTION_CLIENTE.MI_ORGANIZACION])
    : router.createUrlTree([RUTAS.ACCESO_DENEGADO]);
};

export const accesoOrganizacionPropiaGuard: CanActivateFn = () => {
  const permisosService = inject(PermisosService);
  const router = inject(Router);

  return permisosService.tieneAlgunPermiso(PERMISOS_ORGANIZACION_PROPIA)
    ? true
    : router.createUrlTree([RUTAS.ACCESO_DENEGADO]);
};
